import { IEventSubType } from "../../Interfaces";
import { ValueSelect } from "./ValueSelect";

export type EventSubTypeSelectProps = {
  eventSubTypes: IEventSubType[];
  selectedEventSubType: string | null;
  onEventSubTypeChange: (value: string) => void;
  showLabel?: boolean;
};

export const EventSubTypeSelect = ({
  eventSubTypes,
  selectedEventSubType,
  onEventSubTypeChange,
  showLabel = false,
}: EventSubTypeSelectProps) => {
  return (
    <ValueSelect
      labelText="Event Sub Type"
      showLabel={showLabel}
      onValueChange={onEventSubTypeChange}
      data={eventSubTypes}
      namePropName="Name"
      valuePropName="Name"
      selectedValue={selectedEventSubType}
    />
  );
};
